import { commonAvailableTermsSelector } from './OfferSelectors';
export const shouldShowTermSelectorForMultipleSkuIdsSelector = (state, {
  skuIds
}) => {
  const availableTerms = commonAvailableTermsSelector(state, {
    skuIds
  });
  const hasMultipleTerms = availableTerms.length > 1;
  return hasMultipleTerms;
};